import { render, staticRenderFns } from "./LiefengContent3.vue?vue&type=template&id=4e6ccf29&scoped=true&"
import script from "./LiefengContent3.vue?vue&type=script&lang=js&"
export * from "./LiefengContent3.vue?vue&type=script&lang=js&"
import style0 from "./LiefengContent3.vue?vue&type=style&index=0&id=4e6ccf29&lang=less&scoped=true&"
import style1 from "./LiefengContent3.vue?vue&type=style&index=1&id=4e6ccf29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ccf29",
  null
  
)

export default component.exports